import Animation from './animation'
import * as d3 from 'd3-selection'

/*
 * This animation is used when many slices turn into a single slice
 */
class UnsplitSerieAnimation extends Animation {

  match (serie) {
    if (!this.chart.previous) {
      // not an update
      return false
    }

    let ticks0 = this.previous.scalers.x.groupScale.domain()
      , ticks1 = this.scalers.x.groupScale.domain()
      , newSeries = this.series.filter(serie => {
        // We didn't have this serie previously
        return this.previous.series.data().indexOf(serie) === -1
      })

    return ticks0.length === ticks1.length && // Same tick count on bottom
           this.exitingSeries.size() > 1 && // More than one serie being removed
           newSeries.size() === 1 // One new serie
  }

  animate (serie, entering, selection, merged, exiting) {
    let exitingSerie = this.exitingSeries
                           .filter(f => f.id === serie.id) // Get the exiting serie

    if (exitingSerie.size()) {
      this._addAsClipPath(exitingSerie) // Add the clip paths for the series we're removing
      this.exitingSeries
          .selectAll('use')
          .attr('clip-path', d => d.clipUid)
          .call(this.fadeOut, true)
    } else {
      entering.each(d => {
                // Adjust the path's `_current`. It starts in its final location
                d3.select(`#${d.pathUid.id}`)
                  .node()._current = Object.assign({}, d.slice)
              })

      merged.call(this.fadeIn, this.styles)
            .call(this.tweenPath, this.arcTweener)
    }
  }
}

export default UnsplitSerieAnimation
